import { actionGenerator } from '../../utils/store/actionGenerator';
import { ITypedReduxAction } from '../../types/redux';

export enum EHeaderActionTypes {
  OpenLoginPopup = 'header/openLoginPopup',
  OpenRegistrationPopup = 'header/openRegistrationPopup',
}

export type TOpenLoginPopup = ITypedReduxAction<EHeaderActionTypes.OpenLoginPopup>;
export type TOpenLoginPopupAction = () => TOpenLoginPopup;

export const openLoginPopup: TOpenLoginPopupAction = actionGenerator<EHeaderActionTypes.OpenLoginPopup>(
  EHeaderActionTypes.OpenLoginPopup,
);

export type TOpenRegistrationPopup = ITypedReduxAction<EHeaderActionTypes.OpenRegistrationPopup>;
export type TOpenRegistrationPopupAction = () => TOpenRegistrationPopup;

export const openRegistrationPopup: TOpenRegistrationPopupAction =
  actionGenerator<EHeaderActionTypes.OpenRegistrationPopup>(EHeaderActionTypes.OpenRegistrationPopup);

export type THeaderActions = TOpenLoginPopup | TOpenRegistrationPopup;
